import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./App.css"
import TodosList from './TodoList'
import EditTodo from './EditTodo'
import CreateTodo from './CreateTodo'

class App extends Component {
  render() {
    return (
<div className="container">
<CreateTodo />

</div>
  
      // <Router>
      // <div className="container">
      //   <nav className="navbar navbar-expand-sm navbar-light bg-light">
          //  <a class="navbar-brand" href="https://codingthesmartway.com" target="_blank">
          //   <img src={logo} width="30" height="30" alt="CodingTheSmartWay.com" />
          // </a> 
          // <Link to="/create" className="navbar-brand">Todo App</Link> 
          // <div className="collpase navbar-collapse">
          //   <ul className="navbar-nav mr-auto">
              // <li className="navbar-item active">
              //   <Link to="/" className="nav-link">Todos</Link>
              // </li> 
        //       <li className="navbar-item">
        //         <Link to="/create" className="nav-link">Create Todo</Link>
        //       </li>
        //     </ul>
        //   </div>
        // </nav>
        // <br/>
      //  <Route path="/" exact component={TodosList} />
      //   <Route path="/edit/:id" component={EditTodo} />
      //   <Route path="/create" component={CreateTodo} />
      // </div>
    //  </Router>
  
    );
  }
}

export default App;
